import React, { useState } from 'react';

export const InsightRail: React.FC = () => {
  const [expandedSections, setExpandedSections] = useState<Set<string>>(
    new Set(['how-ranges-work']) // Default open on desktop
  );

  const toggleSection = (section: string) => {
    const newExpanded = new Set(expandedSections);
    if (newExpanded.has(section)) {
      newExpanded.delete(section);
    } else {
      newExpanded.add(section);
    }
    setExpandedSections(newExpanded);
  };

  return (
    <div className="space-y-4">
      {/* Card 1 - How Ranges Work */}
      <div className="bg-gray-200 border border-gray-200 rounded-lg shadow-xs overflow-hidden">
        <button
          onClick={() => toggleSection('how-ranges-work')}
          className="w-full px-4 py-3 flex items-center justify-between text-left font-semibold text-gray-900 hover:bg-gray-50 md:cursor-default"
        >
          <span>How Ranges Work</span>
          <span className="md:hidden">
            {expandedSections.has('how-ranges-work') ? '−' : '+'}
          </span>
        </button>
        <div className={`px-4 pb-4 text-xl text-gray-700 space-y-2 ${expandedSections.has('how-ranges-work') ? '' : 'hidden md:block'}`}>
            <ul className="list-disc list-inside space-y-1">
              <li>Recent sales + active listings + buyer activity</li>
              <li>Outliers trimmed (≈ P10–P90)</li>
              <li>Condition adjuster nudges the median up/down</li>
            </ul>
          </div>
      </div>

      {/* Card 2 - Condition Checklist */}
      <div className="bg-gray-200 border border-gray-200 rounded-lg shadow-xs overflow-hidden">
        <button
          onClick={() => toggleSection('condition-checklist')}
          className="w-full px-4 py-3 flex items-center justify-between text-left font-semibold text-gray-900 hover:bg-gray-50 md:cursor-default"
        >
          <span>Condition Checklist</span>
          <span className="md:hidden">
            {expandedSections.has('condition-checklist') ? '−' : '+'}
          </span>
        </button>
        <div className={`px-4 pb-4 text-xl text-gray-700 space-y-3 ${expandedSections.has('condition-checklist') ? '' : 'hidden md:block'}`}>
            <div>
              <div className="font-medium text-gray-900 mb-1">Photos:</div>
              <ul className="list-disc list-inside space-y-0.5 text-gray-600">
                <li>All sides, ports, glass/elements</li>
                <li>Powered-on screen</li>
              </ul>
            </div>
            <div>
              <div className="font-medium text-gray-900 mb-1">Honesty:</div>
              <ul className="list-disc list-inside space-y-0.5 text-gray-600">
                <li>Note wear, dust, dead pixels</li>
                <li>Battery cycles</li>
              </ul>
            </div>
            <div>
              <div className="font-medium text-gray-900 mb-1">Completeness:</div>
              <ul className="list-disc list-inside space-y-0.5 text-gray-600">
                <li>Batteries, caps, cables</li>
                <li>Boxes (adds value)</li>
              </ul>
            </div>
          </div>
      </div>

      {/* Card 3 - Fast Sale Tips */}
      <div className="bg-gray-200 border border-gray-200 rounded-lg shadow-xs overflow-hidden">
        <button
          onClick={() => toggleSection('fast-sale-tips')}
          className="w-full px-4 py-3 flex items-center justify-between text-left font-semibold text-gray-900 hover:bg-gray-50 md:cursor-default"
        >
          <span>Fast Sale Tips</span>
          <span className="md:hidden">
            {expandedSections.has('fast-sale-tips') ? '−' : '+'}
          </span>
        </button>
        <div className={`px-4 pb-4 text-xl text-gray-700 ${expandedSections.has('fast-sale-tips') ? '' : 'hidden md:block'}`}>
            <ul className="list-disc list-inside space-y-1">
              <li>Price inside the band</li>
              <li>Respond within 1 hour</li>
              <li>Ship with tracking same/next business day</li>
            </ul>
          </div>
      </div>

      {/* Card 4 - Policy Reminder */}
      <div className="bg-gray-200 border border-gray-200 rounded-lg shadow-xs overflow-hidden">
        <button
          onClick={() => toggleSection('policy-reminder')}
          className="w-full px-4 py-3 flex items-center justify-between text-left font-semibold text-gray-900 hover:bg-gray-50 md:cursor-default"
        >
          <span>48-Hour Verification Period</span>
          <span className="md:hidden">
            {expandedSections.has('policy-reminder') ? '−' : '+'}
          </span>
        </button>
        <div className={`px-4 pb-4 text-xl text-gray-700 ${expandedSections.has('policy-reminder') ? '' : 'hidden md:block'}`}>
            <p>
              Buyers have 48 hours to confirm items are as described. Honest
              notes and clear photos reduce returns.
            </p>
            <a
              href="/policies"
              className="inline-block mt-2 text-brand-orange hover:underline"
            >
              View full policy →
            </a>
          </div>
      </div>
    </div>
  );
};
